import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Request } from "src/app/parametrage/core/model/request";
import { RequestItem } from "src/app/corporate/core/model/request-item";
import { Corporate } from "src/app/parametrage/core/model/corporate";
import { UserService } from "src/app/shared/directives/user.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { CorporateService } from "src/app/corporate/core/service/corporate.service";
import { RequestItemService } from "src/app/corporate/core/service/request-item.service";
import { UpdateInfoEntrepriseComponent } from "src/app/formulaire/modal/entreprise/update-info-entreprise/update-info-entreprise.component";
import { EditCreditModalComponent } from "src/app/corporate/formulaire/modal/edit-credit-modal/edit-credit-modal.component";
import { Condition } from "src/app/corporate/core/model/condition";
import { ConditionService } from "src/app/corporate/core/service/condition.service";
import { FormAddConditionComponent } from "src/app/corporate/formulaire/modal/form-add-condition/form-add-condition.component";
import { FormEditConditionComponent } from "src/app/corporate/formulaire/modal/form-edit-condition/form-edit-condition.component";
import { ReportingCorporateService } from "src/app/reporting/core/service/reporting-corporate.service";
import { ReportViewerModalComponent } from "src/app/formulaire/modal/viewer/report-viewer-modal/report-viewer-modal.component";
import { CorrespondreDossierModalComponent } from "src/app/formulaire/modal/correspondre-dossier-modal/correspondre-dossier-modal.component";

@Component({
  selector: "app-dossier-info-detail-tab",
  templateUrl: "./dossier-info-detail-tab.component.html",
  styleUrls: ["./dossier-info-detail-tab.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class DossierInfoDetailTabComponent implements OnInit {
  MyPermissions: string[];
  private userPermission = {
    permissions: [],
  };
  @Input() requestId: any;
  items: RequestItem[];
  corporate: Corporate;
  request: Request;

  conditions: Condition[];
  conditionArray: Array<Condition[]> = [];
  displayedStudentsColumnsList: string[] = [
    "id",
    "produit.typeCredit.label",
    "produit.label",
    "montant",
    "actions",
  ];

  reportBlob: any = null;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
    private userService: UserService,
    private _keycloakService: KeycloakService,
    private _requestService: RequestService,
    private _corporateService: CorporateService,
    private _requestItemService: RequestItemService,
    private _conditionService: ConditionService,
    private _reportingCorporateService: ReportingCorporateService
  ) {
    this.MyPermissions = _keycloakService.getAccessPermissions();
    this.userPermission.permissions = this.MyPermissions;
    this.userService.setUser(this.userPermission);
  }

  ngOnInit() {
    this.getRequestById(this.requestId);
    this.getCorporateByRequestId(this.requestId);
    this.getListRequestItemByRequest(this.requestId);
    this.exportDossierCorporate(this.requestId);
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCorporateByRequestId(requestId) {
    this._corporateService.getCorporateByRequestId(requestId).subscribe(
      (data) => {
        this.corporate = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListRequestItemByRequest(requestId) {
    this._requestItemService.getListRequestItemByRequest(requestId).subscribe(
      (data) => {
        this.items = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  exportDossierCorporate(requestId: string) {
    this._reportingCorporateService
      .exportDossier(requestId)
      .subscribe((blob) => {
        this.reportBlob = blob;
      });
  }

  Apercu() {
    if (this.reportBlob != null) {
      const modalRef = this.modalService.open(ReportViewerModalComponent, {
        size: "lg",
        backdrop: "static",
        centered: true,
      });

      modalRef.componentInstance.destination = this.reportBlob;

      modalRef.result.then(
        (data) => {},
        (reason) => {}
      );
    }
  }

  telecharger() {
    this._reportingCorporateService
      .exportDossier(this.requestId)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", this.request.number + ".pdf");
        document.body.appendChild(link);
        link.click();
      });
  }

  updateCustomer(corporateId) {
    const modalRef = this.modalService.open(UpdateInfoEntrepriseComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.corporateId = corporateId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getCorporateByRequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateCredit(requestItemId) {
    const modalRef = this.modalService.open(EditCreditModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestItemId = requestItemId;
    modalRef.componentInstance.workflowCode = this.request.workflow.code;

    modalRef.result.then(
      (data) => {
        // on close
        this.getListRequestItemByRequest(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  getConditionsByRequestItemId(requestitemid) {
    this._conditionService
      .getConditionsByRequestItemId(requestitemid)
      .subscribe(
        (data) => {
          this.conditions = data;
          this.conditionArray[requestitemid] = this.conditions;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  AddCondition(requestItemId) {
    const modalRef = this.modalService.open(FormAddConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestItemId = requestItemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  EditCondition(conditionId, requestItemId) {
    const modalRef = this.modalService.open(FormEditConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.conditionId = conditionId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteCondition(conditionId, requestItemId) {
    this._conditionService
      .deleteCondition(conditionId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getConditionsByRequestItemId(requestItemId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  updateRequest(requestId) {
    const modalRef = this.modalService.open(CorrespondreDossierModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getRequestById(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  
  renouvelle(): void {
    this._router.navigate([this.request.workflow.createForm + "/" + this.request.workflow.code + "/" + this.request.id]);
  }


}
